import { useForm as useFormHook } from "hooks";
import { convertToBooleanSwitch } from "util/transformers";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingMarketingWebsiteAndSupport,
    type OnboardingMarketingWebsiteAndSupportForm
} from "./types";
import useValidationSchema from "./useValidationShema";

export const getInitialValues = ({
    hasCreditLimitPolicy,
    wasTerminatedByAcquirer,
    doesCollectKyc,
    doesCollectKycViaOther,
    hasFullTimeCustomerSupport,
    refundChargebackPolicies = null,
    refundChargebackPoliciesFileKey = null,
    securityRiskManagementInput = null,
    otherSecurityRiskInput = null,
    creditLimitPolicyInput = null,
    fraudToolsInput = null,
    terminatedByAcquirerInput = null,
    collectKycViaOtherInput = null,
    fullTimeCustomerSupportInput = null,
    customerSupportEmail = null
}: Partial<HighRiskMerchant.OnboardingMarketingWebsiteAndSupport>): OnboardingMarketingWebsiteAndSupport => ({
    [FormField.HasCreditLimitPolicy]: convertToBooleanSwitch(hasCreditLimitPolicy),
    [FormField.WasTerminatedByAcquirer]: convertToBooleanSwitch(wasTerminatedByAcquirer),
    [FormField.DoesCollectKyc]: convertToBooleanSwitch(doesCollectKyc),
    [FormField.DoesCollectKycViaOther]: convertToBooleanSwitch(doesCollectKycViaOther),
    [FormField.HasFullTimeCustomerSupport]: convertToBooleanSwitch(hasFullTimeCustomerSupport),
    [FormField.CreditLimitPolicyInput]: creditLimitPolicyInput,
    [FormField.FraudToolsInput]: fraudToolsInput,
    [FormField.TerminatedByAcquirerInput]: terminatedByAcquirerInput,
    [FormField.CollectKycViaOtherInput]: collectKycViaOtherInput,
    [FormField.FullTimeCustomerSupportInput]: fullTimeCustomerSupportInput,
    [FormField.CustomerSupportEmail]: customerSupportEmail,
    [FormField.RefundChargebackPolicies]: refundChargebackPolicies,
    [FormField.RefundChargebackPoliciesFileKey]: refundChargebackPoliciesFileKey,
    [FormField.SecurityRiskManagementInput]: securityRiskManagementInput,
    [FormField.OtherSecurityRiskInput]: otherSecurityRiskInput
});

export const useForm = (onboardingMarketingWebsiteAndSupport: OnboardingMarketingWebsiteAndSupportForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingMarketingWebsiteAndSupport,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
